import AuthorizedDriver from './AuthorizedDriver';

export default AuthorizedDriver;
